<template>
    <aside class="operation">
        <div class="years" v-if="!breakpointDownMd">
            <a href="" @click.prevent="prevYear()"><span class="icon-arrow-right prev"></span></a>
            <p>{{activeYearLabel}}</p>
            <a href="" @click.prevent="nextYear()"><span class="icon-arrow-right next"></span></a>
        </div>
        <custom-select
                class="mobile-custom-select"
                value-field="year"
                label-field="year"
                :options="items"
                v-model="mobileYear"
                @change="changeYear()"
                v-if="breakpointDownMd && mobileYear !== null"></custom-select>
        <ul class="op-filters">
            <li v-for="(item,index) in opeList" :class="opeClasses(item, index)">
                <a href="" @click.prevent="goUrl(item, index)">{{item.label}}</a>
            </li>
        </ul>
        <slot></slot>
    </aside>
</template>

<script>
    import $ from "jquery";
    import {sortBy, findIndex, map} from "lodash"
    import Sticky from "sticky-js"
    import {breakpointDown} from "../../libs/Breakpoints";
    import Scrolling from "../../libs/Scrolling"
    import ScrollMagic from "scrollmagic";
    import Utils from "../../libs/Utils";

    export default {
        props: {
            items: {
                type: Array,
                required: true,
            },
            startValues: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                processedItems: null,
                activeYearIndex: null,
                maxYearIndex: null,
                controller: new ScrollMagic.Controller(),
                menuItem: null,
                menuItemLink: null,
                mobileYear: null
            };
        },
        computed: {
            activeYearLabel() {
                return this.processedItems[this.activeYearIndex].year
            },
            opeList() {
                return this.processedItems[this.activeYearIndex].operations
            },
            breakpointDownMd() {
                return this.$root.breakpointDownMd;
            },
        },
        methods: {
            initFilter() {

                this.processedItems = sortBy(this.items, ["year"]);
                this.processedItems = map(this.processedItems, function (o, index) {
                    o.index = index
                    return o
                })
                this.maxYearIndex = this.processedItems.length - 1
                this.activeYearIndex = findIndex(this.processedItems, function (o) {
                    return o.active === true;
                })


            },
            prevYear() {
                if (this.activeYearIndex === 0) {
                    return
                }
                this.activeYearIndex = this.activeYearIndex - 1

            },
            nextYear() {
                if (this.activeYearIndex === this.maxYearIndex) {
                    return
                }
                this.activeYearIndex = this.activeYearIndex + 1
            },
            opeClasses(item, index) {
                let classes = ""

                if (item.empty) {
                    classes = classes + " inactive"
                }

                /*                if (this.opeList.length === 5) {
                                    classes = classes + " five-items"
                                }*/

                if (index === 4) {
                    classes = classes + " op-eparse"
                }

                if (item.active) {
                    classes = classes + " active"
                }

                return classes;
            },
            goUrl(item, index) {
                if (item.active) {
                    return
                }
                let yearNumber = this.activeYearLabel
                let operationNumber = index + 1
                // let url = window.location.href
                this.$router.push({
                    query: {
                        annee: yearNumber,
                        op: operationNumber,
                    }
                })
                window.location.href = window.location.href
            },
            stickyAside() {

                let marginTop = Scrolling.getHauteurMenu(20)

                this.filtersSticky = new Sticky("aside.operation", {
                    marginTop: marginTop,
                    // stickyClass: "shadow",
                    wrap: true
                });

            },
            initScrollFollow() {
                this.menuItem = $(".list-chapitres li")
                this.menuItemLink = $(".list-chapitres li a")

                this.menuItemLink.each((index, item) => {
                    $(item).on("click", function (event) {
                        event.preventDefault()
                        Scrolling.scrollTo("article.one-rubrique[data-index=\"" + index + "\"]")
                    })
                })

                $("article.one-rubrique").each((index, item) => {

                    let height = $(item).outerHeight()

                    new ScrollMagic.Scene({
                        triggerElement: item,
                        triggerHook: 0.5,
                        offset: 0,
                        duration: height
                    })
                        .addTo(this.controller)
                        // .addIndicators() // add indicators (requires plugin)
                        .on("enter", (event) => {
                            let index = $(item).data("index")
                            this.menuItem.removeClass("active")
                            $(this.menuItem[index]).addClass("active")
                        })

                })

            },
            checkIfCurrentOperation() {
                let opIndex = this.startValues.currentOp - 1
                let yearIndex = findIndex(this.processedItems, (o) => {
                    return o.year === this.startValues.currentYear;
                })

                if (this.opeList[opIndex].active === true && this.processedItems[yearIndex].active === true && Utils.isEmpty(this.$route.query)) {
                    let index = $(".list-chapitres li a").length - 1
                    Scrolling.scrollTo("article.one-rubrique[data-index=\"" + index + "\"]")
                }
            },
            changeYear() {
                this.activeYearIndex = findIndex(this.processedItems, (o) => {
                    return o.year === this.mobileYear;
                })
            }
        },
        created() {
            this.initFilter()
            this.stickyAside()
            // this.checkIfCurrentOperation()
            this.mobileYear = this.activeYearLabel

        },
        mounted() {
            this.initScrollFollow()
        },
        destroyed() {
        }
    };
</script>
